import { 
    gql, 
    useQuery 
} from "@apollo/client";
import { FindMerchantByIdAdminQueryQuery, FindMerchantByIdAdminQueryQueryVariables } from "../../../../../schemaTypes";

export const findMerchantByIdAdminQuery = gql`
  query FindMerchantByIdAdminQuery (
        $id: String!
    ) {
    findMerchantByIdAdmin(
        id: $id
    ) {
      id
      admin {
        id
        shortId
        firstname
        lastname
        email
        phone
        level
        merchantProfile {
          id
          businessName
          businessType
          regCountry
          businessRegNumber
          taxId
          address
          addressAlt
          city
          country
          postcode
          companyName
          username
          industry {
            id
            name
            createdBy{
              id
              role
            }
            createdAt
            updatedAt
          }
          companyLocation
          logoUrl
          bannerUrl
          description
          commissionRate
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      kycStatus
      suspended
      isLocked
      isVerified
      isDeactivated
      forgotPasswordLocked
      onboarding{
        id
        status
        currentStep
      }
      role
      lastLoggedIn
      createdAt
      updatedAt
    }
  }
`;

export interface WithFindMerchantByIdAdmin {
  match: FindMerchantByIdAdminQueryQuery["findMerchantByIdAdmin"] | null;
  loading: boolean;
}

interface Props {
  id: string;
  children: (data: WithFindMerchantByIdAdmin) => React.ReactElement | null;
}

export const FindMerchantByIdAdminController: React.FC<Props> = ({ id, children }) => {
  const { data, loading } = useQuery<
  FindMerchantByIdAdminQueryQuery,
  FindMerchantByIdAdminQueryQueryVariables
  >(
    findMerchantByIdAdminQuery, {
      variables: { id }
    }
);

  let match: FindMerchantByIdAdminQueryQuery["findMerchantByIdAdmin"] | null = null;
  if (data && data.findMerchantByIdAdmin) {
    match = data.findMerchantByIdAdmin;
  }

  return children({
    match,
    loading
  });
};